// React imports.
import React from "react";

import { Assessment2aStepsEnum } from "../state";
import { Assessment2aModel } from "../state";
import { Assessment2aStatusEnum } from "../state";

const Assessment2aQuestions = ({model, state}) => (
    <div>
        {(model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMin5Plus
          || model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMinUnder5)
        &&
            <React.Fragment>
                Please indicate your plans to address this issue in the box below.
                <textarea  name="requestDataMinVendorsDesc"
                    id="requestDataMinVendorsDesc" style={{width:"100%"}}
                    value={model.requestDataMinVendorsDesc}
                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                <p>
                    Looking forward, consider the following issues that may cause vendors to fail
                    to supply electric expenditure data even if you request data from the required
                    number of vendors:
                </p>
                <ol>
                    <li>Your agreements with electricity vendors do not include data collection
                    requirements for households that do not heat with electricity.</li>
                    <li>Your client waivers do not meet electric vendors&rsquo; privacy
                    standards and therefore they feel it would be against their internal
                    policies to share the billing information with you. </li>
                    <li>Your electric vendors are not alerted about data collection in
                    a timely manner and are therefore unable to provide the necessary data
                    before the reporting deadline.</li>
                </ol>
            </React.Fragment>
        }

        {(model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMin5Plus
          ||  model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMinUnder5
          ||  model.viewAnywayFlag === true)
        &&
            <React.Fragment>
                <p>
                    Please answer each of the questions below. Depending on your response,  
                    each question may ask you to outline an action item to help you address the issue.  
                    <strong> If you don't know the answer to a question, please indicate "Don't Know"
                    and provide your plans to acquire this information from IT department or programming
                    staff in the response box.</strong>
                </p>
                <ol>
                    {/*vendorAgreementsHaveDataCollectionReq*/}
                    <li>
                        Do your vendor agreements with electric vendors include data collection requirements?
                        <br/>
                        <label>
                            <input type="radio"
                                name="vendorAgreementsHaveDataCollectionReqFlag"
                                id="vendorAgreementsHaveDataCollectionReqFlag_true"
                                value="Y"
                                checked={model.vendorAgreementsHaveDataCollectionReqFlag === "Y"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorAgreementsHaveDataCollectionReqFlag"
                                id="vendorAgreementsHaveDataCollectionReqFlag_false"
                                value="N"
                                checked={model.vendorAgreementsHaveDataCollectionReqFlag === "N"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorAgreementsHaveDataCollectionReqFlag"
                                id="vendorAgreementsHaveDataCollectionReqFlag_dk"
                                value="U"
                                checked={model.vendorAgreementsHaveDataCollectionReqFlag === "U"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {model.vendorAgreementsHaveDataCollectionReqFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              Vendor agreements should include data collection requirements.
                            </span>
                          }
                        {model.vendorAgreementsHaveDataCollectionReqFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire billing data on enough LIHEAP clients, and a good way 
                              to ensure vendors provide you with this information is to include data
                              collection requirements in your vendor agreements. Your vendors
                              agreements should clearly require electric vendors to supply
                              you with 12 months of electric billing data for LIHEAP-assisted
                              customers on an annual basis, even if the LIHEAP assisted customer
                              does not apply their LIHEAP benefit to their electricity bill.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="vendorAgreementsHaveDataCollectionReqDesc"
                                  id="vendorAgreementsHaveDataCollectionReqDesc" style={{width:"100%"}}
                                  value={model.vendorAgreementsHaveDataCollectionReqDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        {model.vendorAgreementsHaveDataCollectionReqFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You need to know whether your vendor agreements with electric vendors
                              include data collection agreements in order to perform a full
                              assessment. You may need to review your standing vendor agreements
                              to obtain this information. 
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="vendorAgreementsHaveDataCollectionReqDesc"
                                  id="vendorAgreementsHaveDataCollectionReqDesc" style={{width:"100%"}}
                                  value={model.vendorAgreementsHaveDataCollectionReqDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                    {/*clientWaiversMeetVendorRequirements*/}
                    <li>
                        Do your client waivers satisfy electric vendors’ privacy standards for sharing client data?
                        <br/>
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetVendorRequirementsFlag"
                                id="clientWaiversMeetVendorRequirementsFlag_true"
                                value="Y"
                                checked={model.clientWaiversMeetVendorRequirementsFlag === "Y"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetVendorRequirementsFlag"
                                id="clientWaiversMeetVendorRequirementsFlag_false"
                                value="N"
                                checked={model.clientWaiversMeetVendorRequirementsFlag === "N"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetVendorRequirementsFlag"
                                id="clientWaiversMeetVendorRequirementsFlag_dk"
                                value="U"
                                checked={model.clientWaiversMeetVendorRequirementsFlag === "U"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {model.clientWaiversMeetVendorRequirementsFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              Client waivers should satisfy vendors' privacy standards.
                            </span>
                          }
                        {model.clientWaiversMeetVendorRequirementsFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              If client waivers do not meet electric vendors' privacy standards
                              they may refuse to supply you with the billing data that you
                              have requested. Since privacy standards may differ across vendors,
                              you should communicate with your vendors to ensure that your
                              client waivers meet their needs.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="clientWaiversMeetVendorRequirementsDesc"
                                  id="clientWaiversMeetVendorRequirementsDesc" style={{width:"100%"}}
                                  value={model.clientWaiversMeetVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        {model.clientWaiversMeetVendorRequirementsFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You need to know whether client waivers satisfy vendors' privacy
                              standards in order to perform a full assessment. These standards may
                              differ across vendors, so you should communicate with your vendors to ensure they do.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="clientWaiversMeetVendorRequirementsDesc"
                                  id="clientWaiversMeetVendorRequirementsDesc" style={{width:"100%"}}
                                  value={model.clientWaiversMeetVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                    {/*vendorsAlertedTimelyManner*/}
                    <li>
                        Do you send data requests out to your vendors as soon as possible after the end of the Federal Fiscal Year in order to give them ample time to respond before the reporting deadline?
                        <br/>
                        <label>
                            <input type="radio"
                                name="vendorsAlertedTimelyMannerFlag"
                                id="vendorsAlertedTimelyMannerFlag_true"
                                value="Y"
                                checked={model.vendorsAlertedTimelyMannerFlag === "Y"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorsAlertedTimelyMannerFlag"
                                id="vendorsAlertedTimelyMannerFlag_false"
                                value="N"
                                checked={model.vendorsAlertedTimelyMannerFlag === "N"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorsAlertedTimelyMannerFlag"
                                id="vendorsAlertedTimelyMannerFlag_dk"
                                value="U"
                                checked={model.vendorsAlertedTimelyMannerFlag === "U"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {model.vendorsAlertedTimelyMannerFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              Electric vendors should be alerted about data collection in a timely manner. Grant Recipients who are most successful in collecting data from their vendors tend to be those who issue their data requests as quickly after the close of the Federal Fiscal Year as possible.
                            </span>
                          }
                        {model.vendorsAlertedTimelyMannerFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              It is important to provide vendors with enough time to comply with your data request. The Federal Fiscal Year closes on September 30th each year, Grant Recipients who are most successful in collecting data from their vendors tend to be those who issue their data requests as quickly after that date as possible. Looking forward, you should should try to issue your data requests to electric vendors at least 30-60 days in advance of the reporting deadline.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="vendorsAlertedTimelyMannerDesc"
                                  id="vendorsAlertedTimelyMannerDesc" style={{width:"100%"}}
                                  value={model.vendorsAlertedTimelyMannerDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        {model.vendorsAlertedTimelyMannerFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You need to know whether electric vendors are alerted about data 
                              collection in a timely manner in order to perform a full assessment. The  
                              time required by vendors to comply with data collection requirements may
                              differ, so you should communicate with your vendors to ensure they do.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="vendorsAlertedTimelyMannerDesc"
                                  id="vendorsAlertedTimelyMannerDesc" style={{width:"100%"}}
                                  value={model.vendorsAlertedTimelyMannerDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>



                    {/*deliveredFuelSmallElectricVendor*/}
                    <li>
                        Do more than half of your delivered fuel (Fuel Oil and Propane) households receive their baseload electric service from a small electric vendor that is not in your top 5?
                        <br/>
                        <label>
                            <input type="radio"
                                name="deliveredFuelSmallElectricVendorFlag"
                                id="deliveredFuelSmallElectricVendorFlag_true"
                                value="Y"
                                checked={model.deliveredFuelSmallElectricVendorFlag === "Y"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="deliveredFuelSmallElectricVendorFlag"
                                id="deliveredFuelSmallElectricVendorFlag_false"
                                value="N"
                                checked={model.deliveredFuelSmallElectricVendorFlag === "N"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="deliveredFuelSmallElectricVendorFlag"
                                id="deliveredFuelSmallElectricVendorFlag_dk"
                                value="U"
                                checked={model.deliveredFuelSmallElectricVendorFlag === "U"}
                                onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {model.deliveredFuelSmallElectricVendorFlag === "N"
                          &&
                            <span>
                              <strong>No action needed</strong>&nbsp;
                              </span>}
                        {model.deliveredFuelSmallElectricVendorFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You need to know is more than half of your delivered fuel (Fuel Oil and Propane)
                              households receive their baseload electric service from a small electric vendor
                              that is not in your top 5 in order to perform a full assessment. Your IT department
                              may be able to supply you with this information. 
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="deliveredFuelSmallElectricVendorDesc"
                                  id="deliveredFuelSmallElectricVendorDesc" style={{width:"100%"}}
                                  value={model.deliveredFuelSmallElectricVendorDesc}
                                  onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                    {model.deliveredFuelSmallElectricVendorFlag === "Y"
                        &&
                        <li>
                            {/*smallElectricVendorCollectData*/}
                            Do you collect data from small electric vendors who are not in your top 5?
                            <br/>
                            <label>
                                <input type="radio"
                                    name="smallElectricVendorCollectDataFlag"
                                    id="smallElectricVendorCollectDataFlag_true"
                                    value="Y"
                                    checked={model.smallElectricVendorCollectDataFlag === "Y"}
                                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                                />
                                <span>Yes</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="smallElectricVendorCollectDataFlag"
                                    id="smallElectricVendorCollectDataFlag_false"
                                    value="N"
                                    checked={model.smallElectricVendorCollectDataFlag === "N"}
                                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                                />
                                <span>No</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="smallElectricVendorCollectDataFlag"
                                    id="smallElectricVendorCollectDataFlag_dk"
                                    value="U"
                                    checked={model.smallElectricVendorCollectDataFlag === "U"}
                                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}
                                />
                                <span>Don't Know</span>
                            </label>
                            <br/ >
                            {model.smallElectricVendorCollectDataFlag === "Y"
                              && <span>
                                  <strong>No action needed.</strong>   
                                  If you have a significant number of households served by small electric vendors,  
                                  you should collect billing  data from these providers.
                                </span>
                              }
                            {model.smallElectricVendorCollectDataFlag === "N"
                              &&
                                <span>
                                  <strong>Requires followup.</strong>&nbsp;
                                  You are not required to collect data from small rural electric providers
                                  if they are not one of the five largest electric vendors in your state.
                                  However, Grant Recipients often find that many of their delivered fuel clients
                                  live in rural areas and are almost exclusively served by smaller
                                  electric vendors. Some states even have sub-Grant Recipients whose entire
                                  LIHEAP client base is served exclusively by small rural electric
                                  vendors. If either of these situations apply to your program then
                                  it may be worth the extra effort to collect data from these
                                  smaller vendors to ensure the reliability of your data.                                  
                                  <br/><br/>
                                  Please indicate your plans to address this issue in the box below
                                  <textarea  name="smallElectricVendorCollectDataDesc"
                                      id="smallElectricVendorCollectDataDesc" style={{width:"100%"}}
                                      value={model.smallElectricVendorCollectDataDesc}
                                      onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                                </span>}
                            {model.smallElectricVendorCollectDataFlag === "U"
                              &&
                                <span>
                                  <strong>Requires followup.</strong>&nbsp;
                                  You need to know if collect data from small rural electric providers  
                                  in order to perform a full assessment. Your IT department may be able to supply
                                  you with this information.
                                  <br/><br/>
                                  Please indicate your plans for obtaining this information in the box below.
                                  <textarea  name="smallElectricVendorCollectDataDesc"
                                      id="smallElectricVendorCollectDataDesc" style={{width:"100%"}}
                                      value={model.smallElectricVendorCollectDataDesc}
                                      onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                                </span>}
                            <br/><br/>
                        </li>
                    }

                </ol>
                {(model.vendorAgreementsHaveDataCollectionReqFlag === "Y"
                    && model.clientWaiversMeetVendorRequirementsFlag === "Y"
                    && model.vendorsAlertedTimelyMannerFlag === "Y"
                    && (model.deliveredFuelSmallElectricVendorFlag === "N" || model.smallElectricVendorCollectDataFlag === "Y")
                    && !model.viewAnywayFlag === true)
                    &&
                      <span>
                        It appears that your potential data reliability issue cannot be explained
                        by the most common reasons we have found for why states fail to receive
                        data from the minimum required number of vendors for each main heating fuel.
                        Please indicate any explanations for why you have not received data from the proper number of vendors, and your plans to remedy this issue, in the response box below.
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="otherReasonDesc"
                            id="otherReasonDesc" style={{width:"100%"}}
                            value={model.otherReasonDesc}
                            onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, model)}></textarea>
                      </span>
                }
            </React.Fragment>
        }
    </div>
);

export default Assessment2aQuestions;
